(function (root, factory) {
    'use strict';
    if (typeof exports === 'object') {
        // CommonJS
        module.exports = factory(require('@ali/simple-ua'));
    } else {
        // Global Variables
        root.UEM = root.UEM || {};
        root.UEM.network = factory((root.UEM || '').ua);
    }
}(this, function (ua) {
    'use strict';

    // 兼容同构
    if (typeof window === 'undefined') return {};

    var out = {};

    var baseRequestParams = {}, // 每个请求都会带的参数，可通过 baseParam 设置
        baseResponseSuccessHandler, // 每个 response 都会执行的 handler，可通过 baseSuccess 设置
        ucParam, // 为 url 添加 uc 公参和 entry 参数的方法
        globalConfig = {};


    /**
     * 获取对象的类型
     * @param {any} obj - 被检查的对象
     */
    function getType(obj) {
        var type;
        if (obj == null) {
            type = String(obj);
        } else {
            type = Object.prototype.toString.call(obj).toLowerCase();
            type = type.substring(8, type.length - 1);
        }
        return type;
    }

    /**
     * 遍历数组或对象，当迭代函数返回 false 时终止
     * @param {object|array} obj - 需要遍历的对象或数组
     * @param {function} iterator - 迭代器，遍历时调用的迭代函数
     * @param {object} context - 迭代器的 this 上下文对象
     */
    function each(obj, iterator, context) {
        /*jshint curly: false */
        var i,
            l,
            type;
        if (typeof obj !== 'object') {
            return;
        }
        type = getType(obj);
        context = context || obj;
        if (type === 'array' || type === 'arguments' || type === 'nodelist') {
            for (i = 0, l = obj.length; i < l; i++) {
                if (iterator.call(context, obj[i], i, obj) === false) {
                    return;
                }
            }
        } else {
            for (i in obj) {
                if (obj.hasOwnProperty(i)) {
                    if (iterator.call(context, obj[i], i, obj) === false) {
                        return;
                    }
                }
            }
        }
    }

    /**
     * 浅复制
     * @params {object...} args - 多个被复制的对象
     */
    function extend() {
        var obj = {};
        each(arguments, function (arg) {
            each(arg, function (val, key) {
                obj[key] = val;
            });
        });
        return obj;
    }

    /**
     * 获取 url 上的 search 参数值
     * @param {string} key - 参数名
     * @param {string} url - 被查找的 url，默认为当前的 location
     */
    function getQueryParam(key, url) {
        url = url || location.search;
        var hashIndex = url.indexOf('#'),
            keyMatches;
        if (hashIndex > 0) {
            url = url.substr(0, hashIndex);
        }
        keyMatches = url.match(new RegExp('[?|&]' + encodeURIComponent(key) + '=([^&]*)(&|$)'));
        if(keyMatches && keyMatches[1]==='%s'){
            return keyMatches[1];
        }else{
            return keyMatches ? decodeURIComponent(keyMatches[1]) : '';
        }
    }

    /**
     * 将 queryString 拼接在 url 后面
     * @param {string} url - 拼接的 url
     * @param {string} query - queryString
     */
    function _appendQuery2Url(url, query) {
        var hashIndex, hash;
        if (query) {
            hashIndex = url.indexOf('#');
            if (hashIndex >= 0) {
                hash = url.substr(hashIndex);
                url = url.substr(0, hashIndex);
            } else {
                hash = '';
            }
            url += (url.indexOf('?') < 0 ? '?' : '&') + query.replace(/^[?|&]+/, '') + hash;
        }
        return url;
    }


    /**
     * 反序列化 'a=1&b=2&c=d+e' 形式的 querystring 为 对象 {a: 1, b: 2, c: 'd e'}
     * @param {string} queryString - 被查找的 querystring，默认为当前的 location.search
     */
    function parseQueryString2Object(queryString) {
        queryString = (queryString || location.queryString).replace(/^\?/, '');
        var queryArr = queryString.split('&'),
            i,
            queryKeyVal,
            queryObj = {};
        if (queryArr.length) {
            for (i = 0; i < queryArr.length; i++) {
                queryKeyVal = queryArr[i].split('=');
                if (queryKeyVal.length === 2) {
                    if(queryKeyVal[1]==='%s'){
                        queryObj[queryKeyVal[0]] = queryKeyVal[1];
                    }else{
                        queryObj[queryKeyVal[0]] = decodeURIComponent(queryKeyVal[1]);
                    }
                }
            }
        }
        return queryObj;
    }


    /**
     * 序列化对象 {a: 1, b: 2, c: 'd e'} 为 'a=1&b=2&c=d+e' 形式的 querystring
     * @param {object} data - 被转化的对象
     * @param {string} appendTo - ，追加 querystring 的 url
     * @return {string} - 若指定 appendTo，则返回追加 querystring 后的 url，否则直接返回 querystring
     */
    function parseObject2QueryString(data, appendTo) {
        var stack = [],
            query,
            appendUrlHashIndex,
            appendUrlHash = '',
            appendUrlQueryIndex,
            appendUrlQueryObject,
            needAppend = getType(appendTo) === 'string';

        // 解析 appendTo 上面的 queryObject，用 data 覆盖重复的 key
        if (needAppend) {
            appendUrlHashIndex = appendTo.indexOf('#');
            if (appendUrlHashIndex >= 0) {
                appendUrlHash = appendTo.substr(appendUrlHashIndex);
                appendTo = appendTo.substr(0, appendUrlHashIndex);
            }
            appendUrlQueryIndex = appendTo.indexOf('?');
            if (appendUrlQueryIndex >= 0) {
                appendUrlQueryObject = parseQueryString2Object(appendTo.substr(appendUrlQueryIndex));
                data = extend(appendUrlQueryObject, data);
                appendTo = appendTo.substr(0, appendUrlQueryIndex);
            }
        }

        each(data, function (value, key) {
            stack.push(encodeURIComponent(key) + '=' + encodeURIComponent(value === undefined ? '' : value));
        });
        query = stack.join('&').replace(/%20/g, '+');

        return needAppend ? appendTo + '?' + query + appendUrlHash : query;
    }

    /**
     * 为 url 添加 uc 公参和 entry 参数
     * 注意：uc_param_str 放在 url 最后，避免 Android 客户端 10.4.0.(558+) 的 bug
     * @params {string} url - 需要被添加公参的 url 地址
     */
    ucParam = (function () {
        var query,
            entry,
            origin,
            forcela,
            ucParamStr,
            i = 0,
            pName,
            pVal,
            data = {},
            dataWithoutDecryption = {},
            queryWithoutDecryption,
            validLen;
        //头条ajax请求不带公参
        var isucnews = window.navigator.userAgent.toLowerCase().indexOf('ucnewsapp') !== -1 ? true : false;
        var isUClite = ua.pf === 'UCLITE';
        // 部分国际UC浏览器使用了新的内核更新方式，新下载的浏览器都是系统核，在某些特定条件下才会下载并更新U4核，系统核在公参上的表现和news类似
        var isUCBrowser = ua.pf === 'UC';
        // 兼容 头条、WP 和 UCMINI 在 ajax 的时候不带公参
        if (isUClite || isucnews || getQueryParam('fr') === 'wp' || getQueryParam('pf') === '139' || getQueryParam('pf') === '140' || isUCBrowser) {
            ucParamStr = getQueryParam('uc_param_str');
            validLen = ucParamStr.length - ucParamStr.length % 2;
            while (i < validLen) {
                pName = ucParamStr.substr(i, 2);
                pVal = getQueryParam(pName);
                if (pVal.length > 0) {
                    data[pName] = pVal;
                }
                i += 2;
            }
        }
        entry = getQueryParam('entry').replace(/\s/g, '');
        if (entry) {
            dataWithoutDecryption.entry = data.entry = entry;
        }
        origin = getQueryParam('origin').replace(/\s/g, '');
        if (origin) {
            dataWithoutDecryption.origin = data.origin = origin;
        }
        forcela = getQueryParam('forcela').replace(/\s/g, '');
        if (forcela) {
            dataWithoutDecryption.forcela = data.forcela = forcela;
        }
        query = parseObject2QueryString(data);
        queryWithoutDecryption = parseObject2QueryString(dataWithoutDecryption);

        return function (url, withoutDecryption) {
            if(withoutDecryption) {
                url = _appendQuery2Url(url, queryWithoutDecryption);
            } else {
                url = _appendQuery2Url(url, query);
            }
            if (!getQueryParam('uc_param_str', url)) {
                // 客户端确认：U4 内核下部分版本，当公参含有 ch，某些情况下，ch 后面的参数会被全部截断。影响范围：< 12.2.8
                // 目前暂时把 ch 移到公参字符串最后面，降低风险
                url = _appendQuery2Url(url, 'uc_param_str=dsdnfrpfbivessbtbmnilauputogpintnwmtsvpccpprsnch'); 
            }
            return url;
        };
    })();

    /**
     * 获取当前用户访问时长，低端机型需要带上__t参数，避开缓存
     */
    function getDurationTimeParam() {
        try {
            return {
                __dt: +new Date() - window.performance.timing.navigationStart,
                __t: +new Date()
            };
        } catch (e) {
            return {
                __t: +new Date()
            };
        }
    }

    function setRequestHeaderConfig(xhr, headers) {
        for(var headerKey in headers) {
            if (headerKey !== 'Content-Type') xhr.setRequestHeader(headerKey, headers[headerKey]);
        }
    }

    /**
     * ajax 方法(只支持 GET 和 POST)
     * @params {object} options - ajax 的配置
     */
    function ajax(options) {
        options = options || {};
        var type = options.type || 'GET',
            url = options.url || '',
            success = options.success,
            error = options.error || function () {},
            config = options.config || {},
            params = config.forbidExtendRequestParams ? options.data:extend(getDurationTimeParam(), baseRequestParams, options.data),
            xhr = new XMLHttpRequest(),
            formData;
        var stime = Date.now();
        //var statechange = '';
        // 兼容 UC 浏览器的缓存
        xhr.onreadystatechange = function () {
            var res;
            //statechange = statechange ? statechange+';'+ xhr.readyState+'-'+xhr.status:xhr.readyState+'-'+xhr.status;
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    try {
                        res = JSON.parse(xhr.responseText);
                    } catch (e) {
                        // 记录 JSON.parse 错误，方便出错时检查
                        xhr.customError = e;
                        xhr.parseError = true;
                        xhr.xtime = Date.now() - stime;
                        xhr.statechange = xhr.status;
                        xhr.errortime = getQueryParam('__t', url);
                        error(xhr);
                        return;
                    }
                    // 如果设置了 baseResponseSuccessHandler 则先执行
                    if (baseResponseSuccessHandler) {
                        baseResponseSuccessHandler(res);
                    }
                    // 再执行成功回调
                    if (success) {
                        success(res);
                    }
                } else {
                    xhr.xtime = Date.now() - stime;
                    xhr.statechange = xhr.status;
                    xhr.errortime = getQueryParam('__t', url);
                    error(xhr);
                }
            }
        };

        // 设置请求超时时间
        xhr.timeout = config.timeout || 30 * 1000; // 30s

        type = type.toUpperCase() === 'POST' ? 'POST' : 'GET';
        try {
            if (type === 'POST') {
                // 检查是否有上传文件
                each(params, function (val) {
                    if (getType(val) === 'file') {
                        formData = new FormData();
                        return false;
                    }
                });
                url = ucParam(url);
                xhr.open(type, url, true);
                if (formData) {
                    // 有文件类型，使用 multipart/form-data
                    each(params, function (val, key) {
                        if (key && val !== undefined) {
                            formData.append(key, getType(val) === 'array' ? val.join() : val);
                        }
                    });
                    // 不需要 set Content-Type
                    // https://developer.mozilla.org/en-US/docs/Web/API/FormData/Using_FormData_Objects
                } else {
                    var contentType;
                    if (config.headers && ((contentType = config.headers['Content-Type']) === 'application/json')) {
                        formData = JSON.stringify(params);
                        xhr.setRequestHeader('Content-Type', contentType);
                    } else {
                        // 没有文件上传，使用 application/x-www-form-urlencoded
                        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
                        formData = parseObject2QueryString(params);
                        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                    }
                }
                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

            } else {
                // 将 uc_param_str 放在最后
                url = ucParam(parseObject2QueryString(params, url));
                xhr.open(type, url, true);
            }
            xhr.customRequestUrl = url; // 记录请求的 URL，方便出错时检查

            config.headers && setRequestHeaderConfig(xhr, config.headers);
            setXHRConfig(xhr, globalConfig);
            setXHRConfig(xhr, config, [ 'headers' ]);
            xhr.send(formData);
        } catch (e) {
            console.error('ajax error', e);
            // do nothing
        }
    }

    function setXHRConfig(xhr, config, exclude) {
        exclude = exclude || [];
        each(config, function (val, key) {
            if (val && exclude.indexOf(key) === -1) {
                xhr[key] = val;
            }
        });
        return xhr;
    }

    /**
     * 创建一个 GET 或 POST 的 ajax 的 快捷方法
     * @params {string} type - ajax 的 method，'GET' 或 'POST'
     */
    function _typeAjax(type) {
        return function (url, params, success, error, config) {
            ajax({
                type: type,
                url: url,
                data: params,
                success: success,
                error: error,
                config: config,
            });
        };
    }

    /**
     * ping 一个 url 地址
     * @param {string} url - 访问的地址
     * @param {object} data - get 参数
     * @param {function} cb - 回调方法
     */
    out.ping = function (url, data, cb) {
        var img = new Image(),
            params = extend(getDurationTimeParam(), baseRequestParams, data);
        setupPingCallback(img, cb);
        img.src = ucParam(parseObject2QueryString(params, url));
    };

    /**
     * ping 超时等待时间
     */
    var WAIT_TIME_THRESHOLD = 2000;

    /**
     * setup ping callback
     */
    function setupPingCallback(img, cb) {
        var count = 1,
            timer = setTimeout(function () {
                count = pingCallback(count, cb, false);
                timer = null;
            }, WAIT_TIME_THRESHOLD);
        img.onload = img.onerror = function () {
            count = pingCallback(count, cb, true);
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        };
    }

    /**
     * ping callback
     */
    function pingCallback(count, cb, success) {
        if (count && cb) {
            cb(success); // 是否超时
            --count;
        }
        return count;
    }

    /**
     * 设置、获取 baseParam
     * @param {string|object} name - 若为 string，则为被设置、获取的参数名；若为 object，则为设置的对象，并忽略后面的参数
     * @param {string} val - 若为不传参，则返回前面的 name 参数值；否则设置 name 的值为 val
     */
    out.baseParam = function (name, val) {
        if (getType(name) === 'string') {
            if (arguments.length === 1) {
                return baseRequestParams[name];
            } else {
                baseRequestParams[name] = val;
            }
        } else if (getType(name) === 'object') {
            baseRequestParams = extend(baseRequestParams, name);
        }
    };

    /**
     * 设置默认的 success handler
     * @param  {[type]} argument [description]
     */
    out.baseSuccess = function (handler) {
        if (getType(handler) === 'function') {
            baseResponseSuccessHandler = handler;
        }
    };

    /**
     * 重定向
     * @param {string} url 目标地址
     */
    out.redirect = function (url) {
        if (url) {
            // 补全 URL
            if (!/http[s]:\/\//.test(url)) {
                var elLink = document.createElement('a');
                // document.body.appendChild(elLink);
                elLink.href = url;
                url = elLink.href;
                elLink = undefined;
            }
            location.href = ucParam(parseObject2QueryString(baseRequestParams, url));
        }
    };

    out.refreshUCNewsNotUtDs = function () {
        if (ua.pf === 'UCNEWS' && getQueryParam('uc_param_str').length > 0 && !(getQueryParam('ut').length > 0) && !(getQueryParam('ds').length > 0) && !window.localStorage.getItem('netwrok_refreshUCNewsNotUtDs')) {
            setTimeout(function() {
                window.localStorage.setItem('netwrok_refreshUCNewsNotUtDs', true);
                window.location.reload();
            }, 300);
        }
    };

    out.setup = function(config) {
        globalConfig = config;
    };

    /**
     * 对外发布接口
     */
    out.query = getQueryParam;
    out.parseObject = parseQueryString2Object;
    out.parseQuery = parseObject2QueryString;
    out.ucParam = ucParam;
    out.ajax = ajax;
    out.get = _typeAjax('GET');
    out.post = _typeAjax('POST');

    return out;
}));
